/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterLocationRefetchQueryVariables = {
    uriRef: string;
    userZipCode?: string | null;
    userCountryCode?: string | null;
};
export type SbSharedRefineMenuFilterLocationRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterLocation_viewer">;
    } | null;
};
export type SbSharedRefineMenuFilterLocationRefetchQuery = {
    readonly response: SbSharedRefineMenuFilterLocationRefetchQueryResponse;
    readonly variables: SbSharedRefineMenuFilterLocationRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "uriRef",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userZipCode",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterLocationRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuFilterLocation_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SbSharedRefineMenuFilterLocationRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isSearchWithinFilterEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "REFINE_MENU_SEARCH"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
          },
          {
            "kind": "LinkedField",
            "alias": "locations",
            "name": "itemFacetSearch",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "countryCode",
                "variableName": "userCountryCode"
              },
              {
                "kind": "Literal",
                "name": "facetName",
                "value": "location"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "getExactMatches",
                "value": false
              },
              {
                "kind": "Literal",
                "name": "page",
                "value": 1
              },
              {
                "kind": "Variable",
                "name": "uriRef",
                "variableName": "uriRef"
              },
              {
                "kind": "Variable",
                "name": "zipCode",
                "variableName": "userZipCode"
              }
            ],
            "concreteType": "ItemFacetsQueryConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemFacetsQueryEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FilterValueType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "count",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "displayName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "urlLabel",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "linkReference",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SbSharedRefineMenuFilterLocationRefetchQuery",
    "id": "app-buyer-finding/245.0.0-2019-12-18T19:17:17.340Z/SbSharedRefineMenuFilterLocationRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '378191f77b638248107969ede17f9756';
export default node;
